import { UtilityPagesApi } from "../Api";
import { useQuery } from "@tanstack/react-query";
export const useOurPartners = ()=>{
    const utilityPages = new UtilityPagesApi();
    const useOurPartnersQuery = function() {
        let slug = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "our-partners";
        return useQuery([
            "utility-pages",
            slug
        ], ()=>utilityPages.getUtilityPage(slug), {
            refetchOnWindowFocus: false,
            retry: false
        });
    };
    return {
        useOurPartnersQuery
    };
};
